import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["assets"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { getTranslatedErrorMessage } from 'utils/i18n';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { assetQueryKeys } from '.';
export function formatContentUpdatePayload(_ref) {
  var content = _ref.content;
  var changedFields = content.changedFields;
  var patchItem = {};
  changedFields.forEach(function (field) {
    if (field === 'optional') {
      return false;
    } else if (field === 'tags') {
      patchItem.tags = content[field].map(function (tag) {
        return tag.id;
      });
    } else if (field === 'topics') {
      patchItem.topics = content[field].map(function (tag) {
        return tag.id;
      });
    } else {
      patchItem[field] = content[field];
    }
  });
  return patchItem;
}
function useUpdateMultipleAssets(_ref2) {
  var assets = _ref2.assets,
    options = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function patchAssets(_x) {
    return _patchAssets.apply(this, arguments);
  }
  function _patchAssets() {
    _patchAssets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(assets) {
      var updateAssetById, _updateAssetById, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _updateAssetById = function _updateAssetById3() {
              _updateAssetById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(asset) {
                var patchData, data;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      patchData = formatContentUpdatePayload({
                        content: asset
                      });
                      _context.next = 3;
                      return api('patch', "/api/assets/".concat(asset.id), null, patchData);
                    case 3:
                      data = _context.sent;
                      return _context.abrupt("return", data);
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return _updateAssetById.apply(this, arguments);
            };
            updateAssetById = function _updateAssetById2(_x2) {
              return _updateAssetById.apply(this, arguments);
            };
            data = assets.map(updateAssetById);
            return _context2.abrupt("return", Promise.all(data));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _patchAssets.apply(this, arguments);
  }
  var _useMutation = useMutation(patchAssets, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        assets.forEach(function (asset) {
          queryClient.invalidateQueries(assetQueryKeys.singleAsset(asset.id));
        });
        setSuccessAlert({
          title: assets.length > 1 ? t('alert_assets_updated_success') : t('alert_asset_updated_success')
        });
      },
      onError: function onError(error, variables) {
        setAlert({
          title: variables.length > 1 ? t('alert_update_asset_error_plural') : t('alert_update_asset_error'),
          message: getTranslatedErrorMessage(error)
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateMultipleAssets: mutateAsync
  });
}
export default useUpdateMultipleAssets;